export enum CourseCardType {
    HORIZONTAL = 0,
    VERTICAL = 1,
    FAVORITE = 2,
    MINI = 3,
    ADMIN = 4,
    ORIENTATION_FORM = 5,
    STORE_CARD = 6,
	SHOP_CART = 7,
    ONLY_THUMBNAIL = 8,
};
